//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    article: { type: Object, required: true },
    result: { type: Object, default: () => {} }
  },
  data () {
    return {
      expanded: false,
      feedback: null,
      viewTracked: false,
      sliderSettings: {
        centerPadding: '100px',
        slidesToShow: 3,
        responsive: [{
          breakpoint: 800,
          settings: {
            centerMode: false,
            centerPadding: '0px',
            slidesToShow: 1.2
          }
        }]
      }
    }
  },
  computed: {
    isSearchResult () {
      return !!this.result
    }
  },
  watch: {
    expanded (expanded) {
      if (expanded && !this.viewTracked) {
        this.$store.dispatch('support/TRACK_VIEW', this.article.id)
        this.viewTracked = true
      }
    }
  },
  methods: {
    leaveFeedback (isPositive) {
      this.feedback = isPositive
      this.$store.dispatch('support/RATE', { article: this.article.id, rating: isPositive ? 1 : -1 })
    },
    toggle () {
      this.expanded = !this.expanded
      this.$emit('toggle', this.article, this.expanded)
    },
    expand () {
      this.expanded = true
    }
  }
}
